module.exports = __webpack_public_path__ + "static/media/img11.18df29fc.jpg";